/** Default empty-field glyph for *PresenterV2 default slot content. */

export const PRESENTER_VALUE_FALLBACK = '―';
